export default "__VITE_ASSET__a5b3300d__"